// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__1iApq","qmeta":"Video_qmeta__2tkwK"};